<template>
  <ModalDialog
    ref="dialog"
    :title="`Glass ${glassTitle} - Ordered`"
    icon="fa-shopping-cart"
    :showSubmit="false"
    :scrollable="true"
    @closed="onClosed">

    <Spinner v-if="loading" />
    <StaticDataTable class="static-table-list" v-if="!loading && glassSize">
      <template v-slot:header>
        <tr>
          <th>Order</th>
          <th>Customer </th>
          <th>Estimated Date</th>
          <th>Stock Ordered</th>
          <th>Processed Glass Ordered</th>
        </tr>
      </template>
      <template v-slot:body>
        <tr v-for="order in glassSize.orders" :key="order.id">
          <td class="font-weight-bold">
            <LinkOrder :id="order.id" :name="order.sequenceNumber ? order.sequenceNumber : 'Order'" />
          </td>
          <td>
            <LinkContact :id="order.contact.id" :name="order.contact.name" />
          </td>
          <td>
            <span v-if="order.dateEstimated">{{order.dateEstimated | formatDate}}</span>
            <span v-else>Unknown</span>
          </td>
          <td>{{order.sheetsOrdered}}</td>
          <td>{{order.processedOrdered}}</td>
        </tr>
      </template>
      <template v-slot:empty v-if="!glassSize.orders || glassSize.orders.length == 0">No stock currently ordered</template>
    </StaticDataTable>
  </ModalDialog>
</template>

<script>
import _ from 'lodash'
import ModalDialog from '@/components/modalDialog.vue'
import ModalDialogMixin from '@/mixins/modalDialog'
import StaticDataTable from '@/components/table/staticDataTable.vue'

export default {
  name: "GlassSizeOrderDialog",
  mixins: [
    ModalDialogMixin,
  ],
  components: {
    ModalDialog,
    StaticDataTable
  },
  props: {
    stockId: Number,
    glassSizeId: Number
  },
  data() {
    return {
      loading: false,
      glassSize: null
    }
  },
  mounted() {
    this.requestData()
  },
  computed: {
    glassTitle() {
      if(this.glassSize) {
        return `${this.glassSize.height}x${this.glassSize.width}`
      }
      return ''
    }
  },
  methods: {
    show() {
      return ModalDialogMixin.methods.show.call(this, arguments)
    },
    onClosed() {
      this.modalClosed(false)
    },
    requestData() {
      this.loading = true
      this.$apiService.inventoryService.getGlassSize(this.stockId, this.glassSizeId)
      .then(response => {
        this.glassSize = response.data
      })
      .finally(() => {
        this.loading = false
      })
    }
  }
}
</script>